import React from 'react';
import { Col, Row } from 'antd';
import MetricChart from './MetricChart';
import SpendChart from './SpendChart';
import WoPerformanceSection from './WoPerformanceSection';

type MetricChartProps = React.ComponentProps<typeof MetricChart>;
type SpendChartProps = React.ComponentProps<typeof SpendChart>;
type WoPerformanceProps = React.ComponentProps<typeof WoPerformanceSection>;

export type LifeCycleAnalyticsChartsAndPerformanceProps = {
	showCharts: boolean;
	metricChartProps: MetricChartProps;
	spendChartProps: SpendChartProps;
	woPerformanceProps: WoPerformanceProps;
};

const LifeCycleAnalyticsChartsAndPerformance = ({
	showCharts,
	metricChartProps,
	spendChartProps,
	woPerformanceProps,
}: LifeCycleAnalyticsChartsAndPerformanceProps) => {
	if (!showCharts) {
		return null;
	}

	return (
		<>
			<Row gutter={12} className="-mx-1.5 my-3">
				<Col span={12}>
					<MetricChart {...metricChartProps} />
				</Col>
				<Col span={12}>
					<SpendChart {...spendChartProps} />
				</Col>
			</Row>
			<Row gutter={12} className="-mx-1.5 my-3">
				<Col span={24}>
					<WoPerformanceSection {...woPerformanceProps} />
				</Col>
			</Row>
		</>
	);
};

export default LifeCycleAnalyticsChartsAndPerformance;
